module.exports = __webpack_public_path__ + "static/media/broadcast.67d90177.jpg";